import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {CadCartaocreditoComponent} from '../cad-cartaocredito/cad-cartaocredito.component';
import {FaturaAvulsaPublicaService} from './fatura-avulsa-publica.service';

@Component({
  selector: 'app-fatura-avulsa-pagamento',
  templateUrl: './fatura-avulsa-pagamento.component.html',
  styleUrls: ['./fatura-avulsa-pagamento.component.scss']
})
export class FaturaAvulsaPagamentoComponent implements OnInit, OnDestroy {
  @ViewChild('cartaoComponent') cartaoComponent: CadCartaocreditoComponent;
  codigo: string;
  dados: any;
  carregando = true;
  processando = false;
  verificandoStatusLocal = false;
  erro: string;
  erroStatusPix: string;
  private destruido = false;
  forma = 'pix';
  private polling: any;
  private pollingAutenticacao3DS: any;
  private chaveIdempotencia: string;
  private assinaturaTentativaCartao: string;
  urlAutenticacao3DS: string;
  urlAutenticacao3DSSegura: SafeResourceUrl;
  private urlAutenticacao3DSConcluida: string;
  private readonly messageHandler = (event: MessageEvent) => this.recebaRetorno3DS(event);

  constructor(private rota: ActivatedRoute, private service: FaturaAvulsaPublicaService,
              private sanitizer: DomSanitizer) {}

  ngOnInit() {
    window.addEventListener('message', this.messageHandler, false);
    this.codigo = this.rota.snapshot.params.codigo;
    this.service.obtenha(this.codigo).then(dados => this.receba(dados)).catch(() => {
      this.erro = 'Link inválido ou indisponível';
      this.carregando = false;
    });
  }

  ngOnDestroy() {
    this.destruido = true;
    window.removeEventListener('message', this.messageHandler, false);
    this.parePolling();
    this.parePollingAutenticacao3DS();
  }

  get fatura(): any { return this.dados?.fatura || {}; }
  get estadoFinal(): boolean {
    return ['Paga', 'Cancelada', 'Expirada', 'Reembolsada', 'Contestada', 'Chargeback']
      .indexOf(this.fatura.status) >= 0;
  }
  get pagavel(): boolean {
    return !this.fatura.cobrancaPixAutomatico && ['Aberta', 'Vencida'].indexOf(this.fatura.status) >= 0;
  }
  get pagamentoCartaoPendente(): boolean {
    const status = String(this.fatura.cartao?.status || '').toUpperCase();
    return this.pagavel &&
      ['CREATED', 'PROCESSING', 'PENDING', 'ACTIVE', 'REGISTERED', 'PENDING_AUTHENTICATION',
        'WAITING_AUTHENTICATION', 'AUTHORIZED', 'APPROVED', 'CONCLUDED'].indexOf(status) >= 0;
  }
  get autenticacao3DSPendente(): boolean {
    return this.pagamentoCartaoPendente && Boolean(this.fatura.cartao?.urlAutenticar);
  }

  sincronize() {
    if(this.destruido || this.processando || this.verificandoStatusLocal || this.estadoFinal) return;
    this.processando = true;
    const consulta = this.fatura.cobrancaPixAutomatico ? this.service.obtenha(this.codigo) : this.service.sincronize(this.codigo);
    consulta.then(dados => this.receba(dados)).catch(() => this.informeFalhaStatusPix())
      .then(() => this.processando = false);
  }

  pagueComCartao(cartao: any) {
    if(this.processando || !this.pagavel) return;
    this.processando = true;
    this.erro = null;
    const assinatura = this.crieAssinaturaTentativaCartao(cartao);
    if(this.assinaturaTentativaCartao !== assinatura) {
      this.chaveIdempotencia = null;
      this.assinaturaTentativaCartao = assinatura;
    }
    this.chaveIdempotencia = this.chaveIdempotencia || this.crieChave();
    this.service.pagueComCartao(this.codigo, cartao, this.chaveIdempotencia).then(dados => {
      this.receba(dados);
      if(!this.pagamentoCartaoPendente) {
        this.chaveIdempotencia = null;
        this.assinaturaTentativaCartao = null;
      }
    }).catch(erro => {
      console.log(erro)
      const mensagem = erro || 'Não foi possível concluir a cobrança';
      this.cartaoComponent?.exibaErro(mensagem);
    }).then(() => this.processando = false);
  }

  private receba(dados: any) {
    if(this.destruido) return;
    this.erroStatusPix = null;
    this.dados = dados;
    this.carregando = false;
    if(!this.fatura.pix?.disponivel && this.fatura.permiteCartao) this.forma = 'cartao';
    this.atualizeAutenticacao3DS();
    const cartaoPendente = this.pagamentoCartaoPendente;
    if(this.estadoFinal) {
      this.parePolling();
      this.parePollingAutenticacao3DS();
    } else {
      if(this.fatura.pix?.disponivel || cartaoPendente || this.fatura.cobrancaPixAutomatico) this.iniciePolling();
      if(this.autenticacao3DSPendente) this.iniciePollingAutenticacao3DS();
      else this.parePollingAutenticacao3DS();
    }
  }

  private atualizeAutenticacao3DS() {
    const url = this.autenticacao3DSPendente ? this.fatura.cartao?.urlAutenticar : null;
    if(!url || url === this.urlAutenticacao3DSConcluida) {
      this.urlAutenticacao3DS = null;
      this.urlAutenticacao3DSSegura = null;
      return;
    }

    try {
      if(new URL(url).protocol !== 'https:') throw Error('URL 3DS inválida');
      this.urlAutenticacao3DS = url;
      this.urlAutenticacao3DSSegura = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } catch(e) {
      this.urlAutenticacao3DS = null;
      this.urlAutenticacao3DSSegura = null;
    }
  }

  private recebaRetorno3DS(event: MessageEvent) {
    if(event.origin !== window.location.origin || event.data !== 'cellcoin-3ds-return') return;

    this.urlAutenticacao3DSConcluida = this.urlAutenticacao3DS;
    this.urlAutenticacao3DS = null;
    this.urlAutenticacao3DSSegura = null;
    this.sincronize();
  }

  private iniciePolling() {
    if(!this.polling) this.polling = setInterval(() => this.verifiqueStatusLocal(), 10000);
  }

  private verifiqueStatusLocal() {
    if(this.destruido || this.verificandoStatusLocal || this.processando || this.estadoFinal) return;
    this.verificandoStatusLocal = true;
    this.service.obtenha(this.codigo).then(dados => this.receba(dados)).catch(() => this.informeFalhaStatusPix())
      .then(() => this.verificandoStatusLocal = false);
  }

  private informeFalhaStatusPix(): void {
    if(!this.destruido && this.fatura.cobrancaPixAutomatico)
      this.erroStatusPix = 'Não foi possível atualizar o status. A última informação foi mantida; tentaremos novamente.';
  }

  private parePolling() {
    if(this.polling) clearInterval(this.polling);
    this.polling = null;
  }

  private iniciePollingAutenticacao3DS() {
    if(!this.pollingAutenticacao3DS)
      this.pollingAutenticacao3DS = setInterval(() => this.sincronizeAutenticacao3DS(), 30000);
  }

  private sincronizeAutenticacao3DS() {
    if(!this.autenticacao3DSPendente || this.estadoFinal) {
      this.parePollingAutenticacao3DS();
      return;
    }

    if(!this.processando) this.sincronize();
  }

  private parePollingAutenticacao3DS() {
    if(this.pollingAutenticacao3DS) clearInterval(this.pollingAutenticacao3DS);
    this.pollingAutenticacao3DS = null;
  }

  private crieChave(): string {
    const aleatorio = typeof crypto !== 'undefined' && (crypto as any).randomUUID ?
      (crypto as any).randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    return `fatura-publica-${aleatorio}`;
  }

  private crieAssinaturaTentativaCartao(cartao: any): string {
    return JSON.stringify([
      cartao?.ultimosDigitos || '', cartao?.validade || '', cartao?.nome || '',
      cartao?.cvv || '', cartao?.numeroParcelas || 1
    ]);
  }
}
